// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProxSubmissionStatus } from './prox-submission-status';
import { ProxSubmissionStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProxSubmission extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(30) */
  entityId1!: string;
  /** String(30) */
  entityId2!: string;
  /** String */
  error?: string;
  /** Boolean */
  isCombination!: boolean;
  /** Boolean */
  isDelete!: boolean;
  /** Enum FK proxSubmissionStatus */
  proxSubmissionStatusId!: ProxSubmissionStatusEnum;
  /** DateTimeOffset */
  submissionTs?: Date;
  /** String(50) */
  tableName!: string;
  /** FK proxSubmissionStatusId */
  proxSubmissionStatus!: ProxSubmissionStatus;
}

